// src/api/modules/FileApi.js
import Methods from "../methods";

const searchFiles = (context, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `api/files/search/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const filesByBox = (context, payload) => {
  const {boxId, filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;

  const url = `api/files/${boxId}/search?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const saveFile = (context, payload) => {
  const url = `api/files/new`
  return Methods.doPost(context, url, payload.file, null)
}

const editFile = (context, idFile, request) => {
  const url = `api/files/${idFile}/update`;
  return Methods.doPut(context, url, request, null);
};

const exportFilesReportAsync = (context, payload) => {
  const {filters, email} = payload;
  const url = `report/files/export-excel?email=${encodeURIComponent(email)}`;
  return Methods.doPost(context, url, filters, null);
};

const exportFilesReportAsyncFromSession = (context, filters) => {
  const url = "report/files/export-excel/session";
  return Methods.doPost(context, url, filters, null);
};

const loadReportFiles = (context, payload) => {

  const url = `report/files?${payload.params}`;
  //if(!payload.filters.isExport){
  return Methods.doPost(context, url, payload.filters, null)
  /*}
  else {
    return Methods.doPostDonwload(context,url,payload.filters,`report${new Date().getTime()}`,null)
  }*/
};

const saveFilesFromExcel = (context, payload, param) => {
  const url = `api/files/save?${param}`;
  return Methods.doPost(context, url, payload.dataSave, null)
};

const bulkUploadFiles = (context, payload) => {
  const {file, data} = payload;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("data", new Blob([JSON.stringify(data)], {type: "application/json"}));

  const url = `api/files/bulk-upload`;
  return Methods.doPostMultipart(context, url, formData);
};

const getFileTypeByClient = (context, payload) => {
  const url = `api/files/type/${payload.client}`;
  return Methods.doGet(context, url, null)
};

const getFileTypeName = (context, payload) => {
  const url = `api/files/typeName/${payload.idType}`;
  return Methods.doGet(context, url, null)
};

const getReportExportedData = (context, payload) => {
  const url = `report/files/export?${payload.params}`
  return Methods.doPostDonwload2(context, url, {
    data: payload.filters,
    extExport: payload.typeExport
  }, `reporte-files-final-cliente`, null)
}

const loadLowOfFile = (context, payload) => {
  const url = `api/files/lowOfFile/${payload.idClient}`
  return Methods.doGet(context, url, null);
}

const uptLowOfFile = (context, payload) => {
  const url = `api/files/uptLowOfFile/`
  return Methods.doPut(context, url, payload.lowFile, null)
}

export default {
  searchFiles,
  filesByBox,
  saveFile,
  editFile,
  exportFilesReportAsync,
  exportFilesReportAsyncFromSession,
  loadReportFiles,
  saveFilesFromExcel,
  bulkUploadFiles,
  getFileTypeByClient,
  getFileTypeName,
  getReportExportedData,
  loadLowOfFile,
  uptLowOfFile,
}



// WEBPACK FOOTER //
// ./src/api/modules/FileApi.js